import React from 'react';

export interface BreadcrumbItem {
  label: string;
  link?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
  return (
    <nav aria-label="breadcrumb" className={className}>
      <ol className="breadcrumb">
        {items.map((crumb, idx) => (
          <li
            key={idx}
            className={`breadcrumb-item${idx === items.length - 1 ? ' active' : ''}`}
            aria-current={idx === items.length - 1 ? 'page' : undefined}
          >
            {crumb.link && idx !== items.length - 1 ? (
              <a href={crumb.link}>{crumb.label}</a>
            ) : (
              crumb.label
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs; 